import { useState } from "react";
import { FaRegCopy } from "react-icons/fa";
import copy from "copy-to-clipboard";
import styles from "../commanstyles.module.css"; // update this to your actual CSS path

const CopyButton = ({ text }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    copy(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className={styles.copyWrapper}>
      <button
        onClick={handleCopy}
        className={styles.copyButton}
        title="Copy to clipboard"
      >
        <FaRegCopy />
      </button>
      {copied && (
        <div className={styles.tooltip}>
          Copied!
        </div>
      )}
    </div>
  );
};

export default CopyButton;
